/** Default vocabulary (Russian). EN and AZ supply full overrides in their locale files. */
export const messages = {
  "nav.rating": "Рейтинг VPN",
  "nav.protocol": "Протокол оценки",
  "hero.rating": "Рейтинг VPN",
  "hero.criteria": "Параметры оценивания",
  "hero.title": "Звезда НА СВЯЗИ",
  "hero.intro":
    '<div class="font-semibold max-w-[920px] md:text-c2rem xs:text-xl pb-3 md:leading-10">Наши эксперты внимательно изучили сотни ваших запросов и проверили все сервисы по самым строгим критериям безопасности.</div><div class="font-semibold max-w-[920px] md:text-c2rem xs:text-xl md:leading-10">Звезду НА СВЯЗИ получают только те инструменты, которые соответствуют всем требованиям.&nbsp;</div>',
  "nav.contacts": "Контакты",
  "search.placeholder": "Введите название VPN сервиса",
  "main.learnMore": "Узнать детальнее",
  "main.viewRating": "Посмотреть рейтинг",
  "region.label": "Регион:",
  "lang.name.ru": "Russian",
  "lang.name.en": "English",
  "lang.name.az": "Azerbaijani",
  "lang.modalTitle": "Язык",
  "rating.notFoundTitle": 'По запросу "{{query}}" ничего не найдено.',
  "rating.notFoundHint":
    "Проверьте название сервиса и попробуйте еще раз, либо мы еще не проверяли этот сервис...",
  "rating.missingService": "Не нашли свой сервис?",
  "vpn.ruBadge": "Ориентирован на РФ",
  "vpn.hide": "Скрыть",
  "vpn.more": "Подробнее",
  "vpn.goToService": "Перейти к сервису",
  "vpn.promoOnButton": "уже на кнопке",
  "vpn.altLink": "Альтернативная ссылка",
  "vpn.field.starVerified": "Верифицировано Звездой НА СВЯЗИ",
  "vpn.field.jurisdiction": "Юрисдикция",
  "vpn.field.zeroTracking": "Политика No log/Zero tracking",
  "vpn.field.obfuscation": "Обфускация (маскировка)",
  "vpn.field.cryptoPayment": "Возможность анонимной оплаты (криптой)",
  "vpn.field.personalData": "Требует персональные данные при регистрации",
  "vpn.field.support": "Техподдержка",
  "vpn.field.altClients": "Альтернативные клиенты",
  "vpn.field.splitTunneling": "Раздельное туннелирование",
  "vpn.field.protocols": "Поддерживаемые протоколы",
  "common.yes": "Да",
  "common.no": "Нет",
  "common.free": "Бесплатный",
  "common.present": "Есть",
  "common.absent": "Отсутствует",
  "common.altClientsAbsent": "Отсутствуют",
} as const;
